module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro-norming.f3c0278b.mp3";